export default {
  isLoading: false,
  error: false,
  errorMessage: null,
  adminAndStaff: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  adminOrStaff: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  }
};
